/**
 * Keyboard modifier bitmask carried in input.v1 kdown/kup/wheel `mods`
 * (DEVELOPMENT_PLAN.md §6.3). Bit values are wire-normative.
 */
export const MOD = {
    SHIFT: 1,
    CTRL: 2,
    OPTION: 4,
    CMD: 8,
    CAPSLOCK: 16,
    FN: 32,
};
export const MOD_MAX = MOD.SHIFT | MOD.CTRL | MOD.OPTION | MOD.CMD | MOD.CAPSLOCK | MOD.FN; // 63
export function hasMod(mask, bit) {
    return (mask & bit) === bit;
}
/** Build a mods bitmask from a set of booleans. */
export function modsFrom(flags) {
    let m = 0;
    if (flags.shift)
        m |= MOD.SHIFT;
    if (flags.ctrl)
        m |= MOD.CTRL;
    if (flags.option)
        m |= MOD.OPTION;
    if (flags.cmd)
        m |= MOD.CMD;
    if (flags.capsLock)
        m |= MOD.CAPSLOCK;
    if (flags.fn)
        m |= MOD.FN;
    return m;
}
//# sourceMappingURL=mods.js.map